module.exports = __webpack_public_path__ + "h5/img/wuzhou3@2x.5eae2eee.png";